import { parseEmbedUrl } from './utils';
import { EmbedType } from './types';
import { YoutubeEmbed } from './YoutubeEmbed';
import { LoomEmbed } from './LoomEmbed';
import { UnsupportedEmbed } from './UnsupportedEmbed';
import { UnreachableCaseError } from 'ts-essentials';

interface IProps {
  url: string;
}

export const ExternalEmbed = ({ url }: IProps) => {
  const parsedUrl = parseEmbedUrl(url);
  if (parsedUrl.type === EmbedType.Youtube) {
    return <YoutubeEmbed parsedUrl={parsedUrl} />;
  } else if (parsedUrl.type === EmbedType.Loom) {
    return <LoomEmbed parsedUrl={parsedUrl} />;
  } else if (parsedUrl.type === EmbedType.Unsupported) {
    return <UnsupportedEmbed parsedUrl={parsedUrl} />;
  } else {
    throw new UnreachableCaseError(parsedUrl);
  }
};
